module.exports = {
      id: "gzsports-usage",
      viewBox: "0 0 17.95 23.898",
      url: "/" + "sprite-6d93c42890617d6f6477c703e3b36dd9.svg#gzsports",
      toString: function () {
        return this.url;
      }
    }